import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';

/**
 * Wrapper component for Ant Design DatePicker
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design DatePicker functionality and sub-components.
 * 
 * @component
 * @example
 * import { DatePicker } from '../GeneralComponents/ui';
 * 
 * // Single DatePicker
 * <DatePicker />
 * 
 * // RangePicker
 * const { RangePicker } = DatePicker;
 * <RangePicker />
 * 
 * @see https://ant.design/components/date-picker/ - Ant Design DatePicker documentation
 */
const DatePicker = (props) => {
  return <AntDatePicker {...props} />;
};

// Preserve DatePicker sub-components
DatePicker.RangePicker = AntDatePicker.RangePicker;
DatePicker.MonthPicker = AntDatePicker.MonthPicker;
DatePicker.WeekPicker = AntDatePicker.WeekPicker;

export default DatePicker;

